<template>
  <v-form
    ref="form"
    :disabled="disabled"
  >
    <!-- Top edit button -->
    <avs-editInfoButton
      v-if="isEditable"
      :isEnabled="!disabled"
      @click="$event => setEditable(disabled)"
    />
    <div
      v-if="isEditable && !disabled"
      class="mb-5 d-flex justify-center"
    >
      <avs-createButton
        @click.stop="handleCreateSection()"
        :name="$t('actions.new_female', { entity: $t('commons.section').toLowerCase() })"
        :spantext="$t('actions.add', { entity: $t('commons.section').toLowerCase() })"
      />
    </div>

    <v-expansion-panels
      focusable
      v-model="panelOpen"
      class="px-2"
      tile
    >
      <SectionPanel
        v-for="(section, index) in template.sections"
        :key="index"
        v-model="template.sections[index]"
        :companyId="template.company.pk"
        :index="index"
        :disabled="disabled"
        @delete="handleRemoveSection"
        @duplicate="handleDuplicateSection"
      />
    </v-expansion-panels>

    <div v-if="isEditable && !disabled">
      <v-col class="d-flex justify-end gap-4 mt-4">
        <avs-saveButton @click="handleSave" />
        <avs-cancelButton @click="handleCancel" />
      </v-col>
    </div>
  </v-form>
</template>

<script>
import { TemplateService } from "@/services/documents"
import { isEqual, deepClone } from "@/utils/object"
import SectionPanel from "@/components/ri3/documents/SectionPanel.vue"

export default {
  name: "TemplateDetailsForm",
  components: { SectionPanel },
  props: {
    value: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    disabled: true,
    panelOpen: null,
    template: null
  }),
  methods: {
    handleCancel() {
      this.setEditable(false)
      this.setTemplate(this.value)
      this.$emit("cancel")
    },
    handleDuplicateSection(newSection) {
      this.template.sections.push({ ...newSection })
      this.panelOpen = this.template.sections.length - 1
    },
    async handleSave() {
      if (this.$refs.form.validate()) {
        console.log("💾 Sauvegarde avant envoi :", JSON.stringify(this.template, null, 2))
        if (isEqual(this.template, this.value)) {
          // Objects are equal, no changes to perform
          this.$emit("success", false)
          this.setEditable(false)
        } else {
          this.performSave(this.template)
            .then(response => {
              this.$emit("input", response)
              this.$emit("success", true)
              this.setEditable(false)
            })
            .catch(error => {
              const message = error?.response.data?.state
              this.$emit("error", message)
            })
        }
      }
    },
    async performSave(data) {
      return TemplateService.details.put(data)
    },
    setEditable(value) {
      this.disabled = !value
    },
    setTemplate(newValue) {
      this.template = deepClone(newValue)
    },
    handleCreateSection() {
      let newEmptySection = {
        title: "",
        description: null,
        fields: []
      }
      this.template.sections.push(newEmptySection)
      this.panelOpen = this.template.sections.length - 1
    },
    handleRemoveSection(index) {
      this.template.sections.splice(index, 1)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue) {
          this.setTemplate(newValue)
        }
      }
    }
  }
}
</script>
